import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { PureComponent } from 'react';
import classnames from 'classnames';

var Cell = /*#__PURE__*/function (_PureComponent) {
  _inherits(Cell, _PureComponent);

  var _super = _createSuper(Cell);

  function Cell() {
    _classCallCheck(this, Cell);

    return _super.apply(this, arguments);
  }

  _createClass(Cell, [{
    key: "render",
    value: function render() {
      var _classnames;

      var _this$props = this.props,
          prefixCls = _this$props.prefixCls,
          className = _this$props.className,
          hasArrow = _this$props.hasArrow,
          icon = _this$props.icon,
          title = _this$props.title,
          description = _this$props.description,
          help = _this$props.help,
          disabled = _this$props.disabled,
          onClick = _this$props.onClick,
          children = _this$props.children,
          others = _objectWithoutProperties(_this$props, ["prefixCls", "className", "hasArrow", "icon", "title", "description", "help", "disabled", "onClick", "children"]);

      var cls = classnames(prefixCls, className, (_classnames = {}, _defineProperty(_classnames, "".concat(prefixCls, "--disabled"), disabled), _defineProperty(_classnames, "".concat(prefixCls, "--link"), !disabled && !!onClick), _defineProperty(_classnames, "".concat(prefixCls, "--arrow"), hasArrow), _classnames));
      var titleCls = classnames("".concat(prefixCls, "__title"), _defineProperty({}, "".concat(prefixCls, "__title--label"), !!children));
      var iconRender = icon && /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "__icon")
      }, icon);
      var titleRender = title && /*#__PURE__*/React.createElement("div", {
        className: titleCls
      }, title);
      var contentRender = children && /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "__content")
      }, children);
      var arrowRender = hasArrow && /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "__arrow")
      });
      var helpRender = help && /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "__help")
      }, help);
      return /*#__PURE__*/React.createElement("div", _extends({
        className: cls,
        onClick: onClick,
        onTouchStart: function onTouchStart() {}
      }, others), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "__inner")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "__header")
      }, iconRender), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "__body")
      }, titleRender, contentRender), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "__footer")
      }, description), arrowRender), helpRender);
    }
  }]);

  return Cell;
}(PureComponent);

Cell.defaultProps = {
  prefixCls: 'za-cell',
  hasArrow: false,
  disabled: false
};
export { Cell as default };